import { Routes } from '@angular/router';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';
import { DamageReportsPageComponent } from './damage-reports-page.component';
import { DamageReportTabsComponent } from './components/damage-report-tabs/damage-report-tabs.component';
import { DamageReportInformationTabComponent } from './components/damage-report-tabs/damage-report-information-tab/damage-report-information-tab.component';
import { DamageReportAttachmentsTabComponent } from './components/damage-report-tabs/damage-report-attachments-tab/damage-report-attachments-tab.component';

export const DamageReportsRouteName = {
  Main: 'damage-reports',
  Information: 'information',
  Attachments: 'picture-document',
};

export const DAMAGE_REPORTS_ROUTES: Routes = [
  {
    path: '',
    component: DamageReportsPageComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${DamageReportsRouteName.Information}`,
      },
      {
        path: ':id',
        component: DamageReportTabsComponent,
        children: [
          {
            path: DamageReportsRouteName.Information,
            component: DamageReportInformationTabComponent,
            canDeactivate: [
              (component: DamageReportInformationTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
          {
            path: DamageReportsRouteName.Attachments,
            component: DamageReportAttachmentsTabComponent,
          },
        ],
      },
    ],
  },
];
